import { render, staticRenderFns } from "./RedirectManager.vue?vue&type=template&id=864980de&scoped=true&"
import script from "./RedirectManager.vue?vue&type=script&lang=ts&"
export * from "./RedirectManager.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "864980de",
  null
  
)

export default component.exports